<template>
  <div class="vx-row">
    <vx-card>

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">

          <h6 class="ml-2">Campaign </h6> 
         
        </vs-col>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">
        

          <h6 class="ml-2">Sales Developer </h6> 
        

        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">

        
         
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">

          <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="selectCampaign"
              ></CampaignAutocomplete>
                   
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-lg="5"
          vs-sm="4"
          vs-xs="12"
        >
        

        
        <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchSalesDeveloper"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleSalesDeveloper"
                ></SalesDeveloperAutocomplete>
                  

        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">

          <vs-button
            icon="search"
            @click="searchSDAndUserView"
            >Search</vs-button
          >

          <vs-button
          class="ml-5"
            icon="cancel"
            @click="reset"
            >Reset</vs-button
          >
         
        </vs-col>
      </vs-row>

      <span class="ml-5" style="color:red">{{ campaign_required }}</span>
    </vx-card>
    
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";import vSelect from "vue-select";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
export default {
  data: () => ({
    user_id : null,
    user_role : null,
    campaign_required: null,
    encoded_viewing_as_full_name:null,
    viewing_as_full_name : null,
    abilities : null,
    companySDSearchComponentKey: 0,
    companySearchComponentKey: 0,
    selected_sales_developer_id: null,
    selected_sales_developer_name: null,
    campaignId: null,
      campaignName: null,
      selected_campaign: null,


  }),
  components: {
    CampaignAutocomplete,
    SalesDeveloperAutocomplete,
    "v-select": vSelect
  },
  computed: {
  },
  watch: {
  },
  methods: {
    reset(){
              this.companySearchComponentKey += 1;
              this.companySDSearchComponentKey +=1;
              this.selected_campaign = null
              this.selected_sales_developer_id = null
              this.campaign_required = null

    },
   
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(0);
    },
    handleSalesDeveloper() {
      this.selected_sales_developer_id = moduleElomarkUserManagement.state.elomark_user.id;
      this.selected_sales_developer_name = moduleElomarkUserManagement.state.elomark_user.first_name + " " + moduleElomarkUserManagement.state.elomark_user.surname;
      console.log("selected_sales_developer", moduleElomarkUserManagement.state.elomark_user);
    },
    searchSalesDeveloper(inputValue) {
      let data = {};
      data.role = "Sales Developer";
      data.search = inputValue;
      data.campaign_id = this.campaignId;
      var self = this;
      return this.$store
        .dispatch("elomarkUsersManagement/getSalesDeveloperByCampaignId", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    searchSDAndUserView: function() {


      console.log("selected_campaign", this.selected_campaign);

      
      if(this.selected_campaign && this.selected_sales_developer_id != null ){


        this.$router.push({
    path: "/views/sd_campaign_view/" + this.campaignId + "/" + btoa(this.campaignName) + "/" + this.selected_sales_developer_id +  "/" + btoa(this.selected_sales_developer_name)
  });

      }

      else if(this.selected_campaign && this.selected_sales_developer_id == null){

        this.$router.push({
    path: "/views/all_sd_campaign_view/" + this.campaignId + "/" + btoa(this.campaignName)
  });
      }
      else if(this.selected_campaign == null){
        this.campaign_required = "Please select a campaign to continue"
      }
      
      
      // else{
      //   this.campaign_required = "Please select a campaign to continue"
      // }

    },
    selectCampaign() {
      let res = moduleCampaignManagement.state.campaign.datas;
      if (res) {
        this.selected_campaign = res[0];
      }
      this.campaignId = this.selected_campaign.id;
      this.campaignName = this.selected_campaign.campaign_name;

    },
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer{
  cursor: pointer;
}

.item.expanded{
    background-color: white !important;
    color: black !important;
}

.tr-table-state-primary, .vs-table-primary .is-selected {
    background: none !important;
    box-shadow: none !important;
}


.tr-table-state-primary, .vs-table-primary .is-selected {
    color: #626262 !important;
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
}

.address_th{
  padding: 30px;
}

.address_td{
  padding: 30px;
      font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
